import useModuleTranslation from "../infra-no-ui/translation/useModuleTranslation";
import React from "react";

/**
 * Dynamically load translation files pertaining to the sponsorship module.
 * @return {*}
 */
export default function useTranslationSponsorship() {

  // Imports must be memoized so that they don't change on every render
  const imports = React.useMemo(() => ({
    'en': import('./locales/en/sponsorship.json'),
    'fr': import('./locales/fr/sponsorship.json')
  }), []);

  return useModuleTranslation('sponsorship', imports);
}
